// extracted by mini-css-extract-plugin
export default {"left":"ahFzmz","external":"bhFzmz","center":"chFzmz","right":"dhFzmz"};